<markant-platform-requests-widget
  widgetType="contactRequests"
  [loading]="(loading$ | async) || false"
  [openRequestsCount]="request.openNegotiationRequests"
  [inProgressRequestsCount]="request.inProgressNegotiationRequests"
  [primaryChipText]="
    'platformWidget.admin.contactRequests.requestOpen' | transloco
  "
  [secondaryChipText]="
    'platformWidget.admin.contactRequests.requestInProgress' | transloco
  "
></markant-platform-requests-widget>
